<script setup>
import AuthIframe from "./AuthIframe";
</script>

<template>
  <AuthIframe source="auth/reset-recovery-key" />
</template>
